import useUser from "@app/zustand/user";
import { usePreviewView } from "@app/zustand/preview-view";

/** Returns true if the effective role is "admin" (full access). */
export function useIsAdmin(): boolean {
  const user = useUser((state) => state.user);
  const previewRole = usePreviewView((state) => state.previewRole);
  const userRole = (user as { role?: string } | null)?.role;
  const effectiveRole = previewRole ?? userRole;
  return effectiveRole === "admin";
}
